import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import {
  ColumnRangeChart,
  formatData,
  getRankedColorsForCount,
  Layout,
  TableData,
  Tabs,
  tooltipRangeFormatter,
} from '@utilities';

import { DISPLAY_AS } from '../../utilities/helpers';

import styles from './_index.module.scss';

const Rank = ({ data, displayAs = DISPLAY_AS.PERCENT.value, question }) => {
  const [selectedSegmentId, setSelectedSegmentId] = useState();
  const selectedSegment = data?.segments?.find(({ id }) => id === selectedSegmentId);

  const chartToDisplay =
    displayAs === DISPLAY_AS.PERCENT.value
      ? selectedSegment?.chartPct
      : selectedSegment?.chartCount;
  const tableToDisplay =
    displayAs === DISPLAY_AS.PERCENT.value
      ? selectedSegment?.tablePct
      : selectedSegment?.tableCount;

  const colors = useMemo(() => {
    if (!data) return [];
    return getRankedColorsForCount(data.segments?.[0]?.chartCount?.series?.length);
  }, [data]);

  useEffect(() => {
    setSelectedSegmentId(data?.segments?.[0]?.id);
  }, [data?.segments]);

  return (
    <Layout.Flex.Column className={styles['rank']} gap="x-large">
      {data?.segments?.length > 1 && (
        <Tabs
          onChange={setSelectedSegmentId}
          options={data.segments.map(({ id, name }) => ({ label: name, value: id }))}
          value={selectedSegmentId}
        />
      )}
      {selectedSegment && (
        <>
          <ColumnRangeChart
            chart={{ inverted: true }}
            chartTitle={`Answer Options by ${
              displayAs === DISPLAY_AS.PERCENT.value
                ? DISPLAY_AS.PERCENT.label
                : DISPLAY_AS.COUNT.label
            }`}
            colors={colors}
            exportName={question.title}
            series={chartToDisplay?.series}
            tooltip={{
              formatter: function () {
                return tooltipRangeFormatter({ data: this, format: chartToDisplay?.format });
              },
            }}
            xAxis={chartToDisplay?.xAxis}
            yAxis={{
              labels: {
                formatter: function () {
                  return formatData({ format: chartToDisplay?.format, value: this.value });
                },
              },
            }}
          />
          {tableToDisplay && (
            <>
              <hr />
              <TableData columns={tableToDisplay.columns} data={tableToDisplay.data} />
            </>
          )}
        </>
      )}
    </Layout.Flex.Column>
  );
};

Rank.propTypes = {
  data: PropTypes.object,
  displayAs: PropTypes.string,
  question: PropTypes.object.isRequired,
};

export default Rank;
